<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>

      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Přidat skupinu účastníků</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Název skupiny příjemců" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <osobasearch label="Vyberte klienta/spolupracovníka" class="mx-2"></osobasearch>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create()" :loading="sending">Přidat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogDetail"
        persistent
        max-width="900px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
        <v-card flat class="no__radius no__padding-scroll table-wrap__padding gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
          <v-card-title>
            <h2>Detail skupiny</h2>
          </v-card-title>
          <div class="gui-flex gui-flex-rows" v-if="!editMode">
            <v-card color="grey lighten-4" class="pt-3 pl-0 pr-0 pb-1 elevation-0" :class="{'pl-3 pr-3': $vuetify.breakpoint.smAndUp}">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <p class="grey--text caption mb-1">Název skupiny příjemců:</p> <strong>Skupina</strong>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mt-3">
                  <v-flex xs12>
                    <div class="table-border__radius elevation-1">
                      <v-data-table
                        :headers="headersDetail"
                        :items="itemsDetail"
                        hide-actions
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.jmeno }}</td>
                          <td>{{ props.item.klient }}</td>
                          <td>{{ props.item.email }}</td>
                          <td>{{ props.item.telefon }}</td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card-actions class="mt-4">
              <v-btn color="primary" v-if="!editMode" @click="editClick()" class="elevation-0"><v-icon small class="mr-2">edit</v-icon>Upravit</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-3 elevation-0" @click="dialogDetail=false;editMode=false;" v-if="!sending">Zavřít</v-btn>
            </v-card-actions>
          </div>

          <div class="gui-flex gui-flex-rows" v-else>
            <v-card color="grey lighten-4" class="pt-3 pl-0 pr-0 pb-1 elevation-0" :class="{'pl-3 pr-3': $vuetify.breakpoint.smAndUp}">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="Název skupiny příjemců"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <div class="table-border__radius elevation-1 mt-3">
                      <v-data-table
                        :headers="headersUpdate"
                        :items="itemsDetail"
                        hide-actions
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.jmeno }}</td>
                          <td>{{ props.item.klient }}</td>
                          <td>{{ props.item.email }}</td>
                          <td>{{ props.item.telefon }}</td>
                          <td>
                            <v-btn flat icon color="red" class="elevation-0">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card-actions class="mt-4 text-xs-right">
              <v-btn color="primary" class="elevation-0 right" @click="edit()" :loading="sending"><v-icon small class="mr-2">save</v-icon>Uložit</v-btn>
              <v-btn color="red" flat @click="editMode=false" class="right"><v-icon small class="mr-2">rotate_left</v-icon>Vrátit změny</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm9>
                <h3>Skupiny účastníků</h3>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm3 class="text-xs-left text-md-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'mt-3 v-btn--block': $vuetify.breakpoint.xs}" outline @click="createClick()">
                  <v-icon class="mr-2">add</v-icon>
                  Přidat skupinu
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.nazev }}</td>
                  <td>{{ props.item.pocet }}</td>
                  <td class="text-center">
                    <v-btn color="primary" class="elevation-0 ma-0" @click="detailClick(props.item)">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Detail
                    </v-btn>
                    <v-btn flat icon color="red" class="elevation-0">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      editMode: false,
      headers: [
        { text: 'Název skupiny účastníků', value: 'nazev' },
        { text: 'Počet příjemců', value: 'pocet' },
        { text: 'Akce', value: null, sortable: false, align: 'center' }
      ],
      headersDetail: [
        { text: 'Jméno a příjmení', value: 'jmeno' },
        { text: 'Klient/spolupracovník', value: 'klient', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Telefon', value: 'telefon', sortable: false }
      ],
      headersUpdate: [
        { text: 'Jméno a příjmení', value: 'jmeno' },
        { text: 'Klient/spolupracovník', value: 'klient', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Telefon', value: 'telefon', sortable: false },
        { text: 'Smazat', value: null, sortable: false }
      ],
      items: [
        {
          nazev: 'Skupina',
          pocet: '7'
        }
      ],
      itemsDetail: [
        {
          jmeno: 'Jan Smrťák',
          klient: 'Klient',
          email: 'smrtak@konec.cz',
          telefon: '+420 777 888 999'
        }
      ],
      dialogCreate: false,
      dialogDetail: false,
      sending: false,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ]
    }
  },
  mounted: function() {
    window.MenuListener.show();
  },
  props: {
    id: String
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    detailClick (e) {
      //this.detailItem = window.th.copy(e);
      this.dialogDetail = true;
    },
    createClick () {
      //this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    editClick () {
      //this.newItem = window.th.copy(this.dialogInit);
      this.editMode = true;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Udalosti/SkupinyUcastniku.vue